import { useContext } from "react";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { createReguaCobranca } from "../../../../repositories/qerpapi/erp/faturamento/ReguaCobrancaRepository";
import { notify } from "../../../../utils/notify";
import { validNotNull } from "../../../../utils/validations";
import { ReguaCobrancaContext } from "../contexts/ReguaCobrancaContext";

const useReguaCobrancaController = () => {
  const {
    checkBeforeExpiration,
    checkOnExpiration,
    checkPendency,
    checkWarningSuspension,
    checkSuspension,
    checkToThank,

    daysBeforeExpiration,
    daysPendency,
    daysWarningSuspension,
    daysSuspension,

    setErrors,
    setLoading,
  } = useContext(ReguaCobrancaContext);
  const { queryParams } = useContext(QueryParamsContext);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const convertToNumber = (value) =>
        parseInt(value.replace(/[^0-9]+/g, ""));

      let requireds = [];

      if (checkBeforeExpiration) {
        requireds.push({
          value: convertToNumber(daysBeforeExpiration),
          key: "daysBeforeExpiration",
        });
      }

      if (checkPendency) {
        requireds.push({
          value: convertToNumber(daysPendency),
          key: "daysPendency",
        });
      }

      if (checkWarningSuspension) {
        requireds.push({
          value: convertToNumber(daysWarningSuspension),
          key: "daysWarningSuspension",
        });
      }

      if (checkSuspension) {
        requireds.push({
          value: convertToNumber(daysSuspension),
          key: "daysSuspension",
        });
      }

      const respValidation = validNotNull(requireds);

      setErrors(respValidation.errorsValidation);

      if (respValidation.error)
        return notify("Preencha os campos obrigatórios.");

      const body = {
        regua_cobranca: {
          empresa_id: queryParams.empresa_id,
          aviso_pre_vencimento_dias: convertToNumber(daysBeforeExpiration),
          aviso_vencimento_flag: checkOnExpiration ? 1 : 0,
          aviso_pendencia_dias: convertToNumber(daysPendency),
          aviso_suspensao_dias: convertToNumber(daysWarningSuspension),
          suspensao_dias: convertToNumber(daysSuspension),
          agradecimento_pagamento_flag: checkToThank ? 1 : 0,
        },
      };

      const response = await createReguaCobranca({
        empresa_cnpj: queryParams.empresa_cnpj,
        body,
      });

      if (response?.success) {
        notify("Régua de cobrança atualizada com sucesso.", true, "success");

        return;
      }

      notify("Não foi possível salvar.");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    handleSubmit,
  };
};

export default useReguaCobrancaController;
